import React from 'react';
import { Feed, Label, Message, Grid } from 'semantic-ui-react';
import './Timeline.css';

const TimelineMarker = () => (
    <Feed.Label className="timelineMarker">
        <span className="timelineDot" />
    </Feed.Label>
);

const Timeline = () => (

        <Grid centered verticalAlign="middle">
            <Grid.Row>
                <Grid.Column computer="10" tablet="15" mobile="15">
                    <Feed size="large" className="experienceTimeline">

                        {/* HERTZ */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Senior JavaScript Developer</strong>, Hertz
                                    <Feed.Date>
                                        Dublin, April 2021 - Present
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developing enterprise-scale web applications for Hertz's global digital platform,
                                        serving millions of customers worldwide. Building scalable React applications,
                                        reusable UI components and microfrontend architecture using React, TypeScript,
                                        GraphQL and Adobe Experience Manager (AEM). Collaborating within Agile teams,
                                        contributing to Design Systems, accessibility improvements, CI/CD pipelines and
                                        high-quality user experiences.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-typescript-plain colored timelineIcon" />
                                            TypeScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            React
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-graphql-plain colored timelineIcon" />
                                            GraphQL
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-apollographql-original colored timelineIcon" />
                                            Apollo Client
                                        </Label>

                                        <Label as="a">Module Federation</Label>

                                        <Label as="a">Micro Frontends</Label>

                                        <Label as="a">
                                            <i className="devicon-materialui-plain colored timelineIcon" />
                                            Material UI
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-storybook-plain colored timelineIcon" />
                                            Storybook
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-jest-plain colored timelineIcon" />
                                            Jest
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-cypressio-plain colored timelineIcon" />
                                            Cypress
                                        </Label>

                                        <Label as="a">
                                            Adobe Experience Manager (AEM)
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-git-plain colored timelineIcon" />
                                            Git
                                        </Label>

                                        <Label as="a">
                                            <i className="devicons devicons-jenkins timelineIcon" />
                                            Jenkins
                                        </Label>

                                        <Label as="a">CI/CD</Label>

                                        <Label as="a">
                                            <i className="devicon-jira-plain colored timelineIcon" />
                                            Jira
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-confluence-plain colored timelineIcon" />
                                            Confluence
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-figma-plain colored timelineIcon" />
                                            Figma
                                        </Label>

                                        <Label as="a">Zeroheight</Label>

                                        <Label as="a">Microsoft Teams</Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* UNUM */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Senior JavaScript Developer</strong>, UNUM
                                    <Feed.Date>
                                        Carlow, January - April 2021
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developed an enterprise insurance platform for the US market, delivering new
                                        features and maintaining large-scale Vue.js applications. Worked with modern
                                        front-end architecture, automated testing and accessibility while collaborating
                                        closely with designers, QA engineers and backend developers in Agile teams.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-typescript-plain colored timelineIcon" />
                                            TypeScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-vuejs-plain colored timelineIcon" />
                                            Vue.js
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-vuejs-plain colored timelineIcon" />
                                            Vuex
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-jest-plain colored timelineIcon" />
                                            Jest
                                        </Label>

                                        <Label as="a">React Testing Library</Label>
                                        <Label as="a">ARIA</Label>
                                        <Label as="a">Rally</Label>
                                        <Label as="a">Overflow</Label>
                                        <Label as="a">InVision</Label>
                                        <Label as="a">Microsoft Teams</Label>

                                        <Label as="a">
                                            <i className="devicons devicons-jenkins timelineIcon" />
                                            Jenkins
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-git-plain colored timelineIcon" />
                                            Git
                                        </Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* NEILSON */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Senior JavaScript Developer</strong>, Neilson Financial Services
                                    <Feed.Date>
                                        Dublin, October - December 2020
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developed customer-facing insurance applications for a leading financial services
                                        company, building responsive and SEO-friendly web applications using Vue.js,
                                        Nuxt.js and Kentico CMS. Worked closely with UX designers and backend developers
                                        to deliver high-quality digital experiences.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-vuejs-plain colored timelineIcon" />
                                            Vue.js
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-vuejs-plain colored timelineIcon" />
                                            Nuxt.js
                                        </Label>

                                        <Label as="a">Kentico CMS</Label>

                                        <Label as="a">
                                            <i className="devicon-sass-original colored timelineIcon" />
                                            Sass
                                        </Label>

                                        <Label as="a">Mobile First</Label>
                                        <Label as="a">Responsive Design</Label>

                                        <Label as="a">
                                            <i className="devicon-git-plain colored timelineIcon" />
                                            Git
                                        </Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* HMH */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Senior JavaScript Developer</strong>, Houghton Mifflin Harcourt
                                    <Feed.Date>
                                        Dublin, May 2015 - June 2020
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developed HMH Ed, a large-scale educational platform used daily by millions of
                                        teachers and students across North America. Built enterprise Single Page
                                        Applications using React, Redux, Angular and AngularJS while contributing to
                                        frontend architecture, GraphQL integration, automated testing and CI/CD pipelines
                                        within Agile teams.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-typescript-plain colored timelineIcon" />
                                            TypeScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            React
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            React Hooks
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            React Testing Library
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-storybook-plain colored timelineIcon" />
                                            Storybook
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            React Native
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            Redux
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-react-original colored timelineIcon" />
                                            Redux Saga
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-angular-plain colored timelineIcon" />
                                            Angular
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-angularjs-plain colored timelineIcon" />
                                            AngularJS
                                        </Label>

                                        <Label as="a">Lodash</Label>
                                        <Label as="a">Yarn</Label>

                                        <Label as="a">
                                            <i className="devicon-webpack-plain colored timelineIcon" />
                                            Webpack
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-grunt-line colored timelineIcon" />
                                            Grunt
                                        </Label>

                                        <Label as="a">
                                            <i className="devicons devicons-npm timelineIcon" />
                                            NPM
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-bower-line colored timelineIcon" />
                                            Bower
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-nodejs-plain colored timelineIcon" />
                                            Node.js
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-html5-plain colored timelineIcon" />
                                            HTML5
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-css3-plain colored timelineIcon" />
                                            CSS3
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-less-plain-wordmark colored timelineIcon" />
                                            LESS
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-d3js-plain colored timelineIcon" />
                                            D3
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-docker-plain colored timelineIcon" />
                                            Docker
                                        </Label>

                                        <Label as="a">
                                            <i className="devicons devicons-jenkins timelineIcon" />
                                            Jenkins
                                        </Label>

                                        <Label as="a">Bamboo</Label>

                                        <Label as="a">
                                            <i className="devicon-jest-plain colored timelineIcon" />
                                            Jest
                                        </Label>

                                        <Label as="a">WebdriverIO</Label>

                                        <Label as="a">
                                            <i className="devicon-jasmine-original colored timelineIcon" />
                                            Jasmine
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-protractor-plain colored timelineIcon" />
                                            Protractor
                                        </Label>

                                        <Label as="a">Pact</Label>

                                        <Label as="a">
                                            <i className="devicon-git-plain colored timelineIcon" />
                                            Git
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-sourcetree-original colored timelineIcon" />
                                            Sourcetree
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-webstorm-plain colored timelineIcon" />
                                            Webstorm
                                        </Label>

                                        <Label as="a">Electron</Label>

                                        <Label as="a">
                                            <i className="devicon-graphql-plain colored timelineIcon" />
                                            GraphQL
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-apollographql-original colored timelineIcon" />
                                            Apollo Client
                                        </Label>

                                        <Label as="a">single-spa</Label>
                                        <Label as="a">Teams</Label>
                                        <Label as="a">Zeplin</Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* MOBEO */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>JavaScript Developer</strong>, Mobeo
                                    <Feed.Date>
                                        Dublin, Mar 2015 - May 2015
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developed the Tesco Community Fund application used by Tesco managers across
                                        Ireland while also building and maintaining promotional landing pages. Worked
                                        across both frontend and backend using JavaScript, AngularJS, PHP and CodeIgniter
                                        to deliver new features and support existing applications.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-angularjs-plain colored timelineIcon" />
                                            AngularJS
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-grunt-line colored timelineIcon" />
                                            Grunt
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-nodejs-plain colored timelineIcon" />
                                            Node.js
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-html5-plain colored timelineIcon" />
                                            HTML5
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-css3-plain colored timelineIcon" />
                                            CSS3
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-bootstrap-plain colored timelineIcon" />
                                            Bootstrap
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-php-plain colored timelineIcon" />
                                            PHP
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-codeigniter-plain colored timelineIcon" />
                                            CodeIgniter
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-mysql-original colored timelineIcon" />
                                            MySQL
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-bower-line colored timelineIcon" />
                                            Bower
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-git-plain colored timelineIcon" />
                                            Git
                                        </Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* CONNECTMEDICA */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Front End Developer</strong>, Connectmedica
                                    <Feed.Date>
                                        Warsaw, Sep 2013 - Jan 2015
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developed and maintained web portals, marketing websites and digital presentations
                                        for leading pharmaceutical companies including Roche, AstraZeneca, GSK and USP
                                        Zdrowie. Focused on responsive, cross-browser front-end development while
                                        collaborating with designers and business stakeholders.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-jquery-plain colored timelineIcon" />
                                            jQuery
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-html5-plain colored timelineIcon" />
                                            HTML5
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-css3-plain colored timelineIcon" />
                                            CSS3
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-less-plain-wordmark colored timelineIcon" />
                                            LESS
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-sass-original colored timelineIcon" />
                                            Sass
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-bootstrap-plain colored timelineIcon" />
                                            Bootstrap
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-php-plain colored timelineIcon" />
                                            PHP
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-rails-plain timelineIcon" />
                                            Rails
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-symfony-original timelineIcon" />
                                            Symfony
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-bower-line colored timelineIcon" />
                                            Bower
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-git-plain colored timelineIcon" />
                                            Git
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-photoshop-line timelineIcon" />
                                            Photoshop
                                        </Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* STAR DIGITAL */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Front End Developer</strong>, Star Digital Sp z o.o.
                                    <Feed.Date>
                                        Warsaw, Mar 2012 - Jul 2012
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Developed landing pages and customer-facing web applications, including Facebook
                                        commerce solutions, while maintaining multiple client websites and marketing
                                        pages. Delivered responsive front-end solutions using JavaScript, PHP and
                                        CodeIgniter.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-jquery-plain colored timelineIcon" />
                                            jQuery
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-html5-plain colored timelineIcon" />
                                            HTML5
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-css3-plain colored timelineIcon" />
                                            CSS3
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-php-plain colored timelineIcon" />
                                            PHP
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-codeigniter-plain colored timelineIcon" />
                                            CodeIgniter
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-mysql-original colored timelineIcon" />
                                            MySQL
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-photoshop-line timelineIcon" />
                                            Photoshop
                                        </Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>


                        {/* RADI ART */}
                        <Feed.Event className="timelineEvent">
                            <TimelineMarker />

                            <Feed.Content>
                                <Feed.Summary>
                                    <strong>Full Stack Developer</strong>, Radi Art
                                    <Feed.Date>
                                        Warsaw, June 2007 - Mar 2012
                                    </Feed.Date>
                                </Feed.Summary>

                                <Feed.Meta>
                                    <Message floating size="large">
                                        Founded and operated a freelance web development business for nearly five years,
                                        delivering websites, e-commerce platforms and custom web applications for clients
                                        across multiple industries. Managed the complete project lifecycle, including
                                        design, frontend development, backend implementation, testing, deployment and
                                        direct client communication.
                                    </Message>

                                    <Label.Group size="large">
                                        <Label as="a">
                                            <i className="devicon-javascript-plain colored timelineIcon" />
                                            JavaScript
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-jquery-plain colored timelineIcon" />
                                            jQuery
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-html5-plain colored timelineIcon" />
                                            HTML5
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-css3-plain colored timelineIcon" />
                                            CSS3
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-php-plain colored timelineIcon" />
                                            PHP
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-codeigniter-plain colored timelineIcon" />
                                            CodeIgniter
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-wordpress-plain colored timelineIcon" />
                                            WordPress
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-mysql-original colored timelineIcon" />
                                            MySQL
                                        </Label>

                                        <Label as="a">
                                            <i className="devicon-photoshop-line timelineIcon" />
                                            Photoshop
                                        </Label>
                                    </Label.Group>
                                </Feed.Meta>
                            </Feed.Content>
                        </Feed.Event>

                    </Feed>
                </Grid.Column>
            </Grid.Row>
        </Grid>

);

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Timeline.js